import React, { FC } from 'react';

import { EvButton, EvSvgIcon, IEvButtonProps } from '@evinced-private/ui-common';

import './IconTextButton.scss';

interface IIconTextButtonProps extends Omit<IEvButtonProps, 'children' | 'title'> {
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	label: string;
}

export const IconTextButton: FC<IIconTextButtonProps> = ({
	icon,
	label,
	...buttonProps
}: IIconTextButtonProps) => {
	return (
		<EvButton {...buttonProps}>
			<span className="icon-text-button__icon">
				<EvSvgIcon icon={icon} isSmall />
			</span>
			{label}
		</EvButton>
	);
};
